const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  editorStat: (state) => state.app.editorStat,
  financeStat: (state) => state.app.financeStat,
  sysName: (state) => state.app.sysName,
  //f_skCount:(state) => state.app.financeStat.skCount,

  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  role: (state) => state.user.role,

  permission_routes: (state) => state.permission.routes,
  errorLogs: (state) => state.errorLog.logs,

  authorArticleCount1: (state) => state.user.authorArticleCount1,
  authorArticleCount2: (state) => state.user.authorArticleCount2,
  authorArticleCount3: (state) => state.user.authorArticleCount3,
}
export default getters
